import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './BulkPurchasePage.css';

const getApiBaseUrl = () => {
  const host = window.location.hostname;
  if (host.includes('localhost')) return 'http://localhost:8000';
  if (host.includes('whatquiztest')) return 'https://quiz-api-test-397277209875.us-central1.run.app';
  return 'https://quiz-api-397277209875.us-central1.run.app';
};

const BulkPurchaseRefundPage = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const initialOrderId = params.get('orderId') || '';

  const [orderId, setOrderId] = useState(initialOrderId);
  const [contactName, setContactName] = useState('');
  const [email, setEmail] = useState('');
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg('');

    if (!orderId.trim() || !contactName.trim() || !email.trim() || !reason.trim()) {
      setErrorMsg('모든 필수 항목을 입력해주세요.');
      return;
    }

    setSubmitting(true);
    try {
      const res = await fetch(`${getApiBaseUrl()}/api/bulk-purchase/refund-request`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          order_id: orderId.trim(),
          contact_name: contactName.trim(),
          email: email.trim().toLowerCase(),
          reason: reason.trim(),
        }),
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || '환불 요청 처리에 실패했습니다.');
      }
      setDone(true);
    } catch (err) {
      setErrorMsg(err?.message || '환불 요청 처리 중 오류가 발생했습니다.');
    } finally {
      setSubmitting(false);
    }
  };

  if (done) {
    return (
      <div className="bulk-page">
        <div className="bulk-container">
          <div className="bulk-section" style={{ textAlign: 'center', padding: '40px 28px' }}>
            <h1 className="bulk-title" style={{ marginBottom: 12 }}>환불 요청이 접수되었습니다</h1>
            <p style={{ color: '#4B5563', fontSize: 14, lineHeight: 1.7 }}>
              영업일 기준 1~2일 내 <strong>angel@plactical.com</strong> 에서 안내드립니다.<br />
              발급된 쿠폰 중 <strong>이미 등록된 쿠폰은 환불 대상에서 제외</strong>되니 양해 부탁드립니다.
            </p>
            <button className="bulk-submit" style={{ marginTop: 24, height: 48 }} onClick={() => navigate('/')}>홈으로</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bulk-page">
      <div className="bulk-container">

        <header className="bulk-header">
          <button className="bulk-back" onClick={() => navigate(-1)} aria-label="뒤로">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>
            </svg>
          </button>
          <div>
            <h1 className="bulk-title">대량 구매 환불 요청</h1>
            <p className="bulk-subtitle">자동 환불은 지원되지 않으며, 영업일 기준 1~2일 내 수동으로 처리됩니다.</p>
          </div>
        </header>

        <form className="bulk-section" onSubmit={handleSubmit}>
          <div className="bulk-notice" style={{ marginBottom: 20 }}>
            <p className="bulk-notice-title">환불 정책 안내</p>
            <ul>
              <li>이미 등록(사용)된 쿠폰은 환불 대상에서 제외됩니다.</li>
              <li>요청 접수 후 토스페이먼츠 결제 취소 + 잔여 쿠폰 비활성화로 처리됩니다.</li>
              <li>환불 진행 결과는 결제 시 입력하신 이메일로 회신해 드립니다.</li>
            </ul>
          </div>

          <div className="bulk-field">
            <label>주문번호 *</label>
            <input
              type="text"
              placeholder="WHATQUIZ_BULK_..."
              value={orderId}
              onChange={(e) => setOrderId(e.target.value)}
              style={{ fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace', fontSize: 13 }}
            />
            <p className="bulk-field-hint">결제 완료 메일에 포함된 주문번호를 입력해주세요.</p>
          </div>

          <div className="bulk-row">
            <div className="bulk-field">
              <label>담당자 이름 *</label>
              <input type="text" placeholder="홍길동" value={contactName} onChange={(e) => setContactName(e.target.value)} maxLength={40} />
            </div>
            <div className="bulk-field">
              <label>결제 시 입력한 이메일 *</label>
              <input type="email" placeholder="example@school.kr" value={email} onChange={(e) => setEmail(e.target.value)} maxLength={120} />
            </div>
          </div>

          <div className="bulk-field">
            <label>환불 사유 *</label>
            <textarea
              rows={4}
              placeholder="환불 사유를 자세히 알려주세요. 미사용 쿠폰 수량을 알려주시면 처리가 빨라집니다."
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              maxLength={500}
              style={{
                width: '100%',
                boxSizing: 'border-box',
                padding: '12px 14px',
                border: '1px solid #E5E7EB',
                borderRadius: 10,
                fontSize: 14,
                fontFamily: 'inherit',
                resize: 'vertical',
                minHeight: 100,
              }}
            />
          </div>

          {errorMsg && <div className="bulk-error">{errorMsg}</div>}

          <button type="submit" className="bulk-submit" disabled={submitting}>
            {submitting ? <span className="bulk-spinner" /> : '환불 요청 보내기'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default BulkPurchaseRefundPage;
